export function getDateDifferenceInDays(futureDate: number) {
    return Math.ceil((new Date(futureDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
}
